const TODESCHINI = "todeschini";
const ITALINEA = "italinea";
const CRIARE = "criare";

export { TODESCHINI, ITALINEA, CRIARE };
